/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @author: Matthew Rawson @ 18/09/2017 12:10
 * @description: New Tab Icon created as a React element in a similar manner to react-icons.
 * @notes: Could be moved to icon font file when that is implemented
 */
import React from "react";
import BaseSvgIcon from "./Base";
var NewTab = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props),
        React.createElement("path", { d: "M16.2513205,3 L12.5,3 L12.5,3 C12.2238576,3 12,2.77614237 12,2.5 C12,2.22385763 12.2238576,2 12.5,2 L17.5,2 L17.5,2 C17.6380712,2 17.7630712,2.05596441 17.8535534,2.14644661 C17.9440356,2.23692881 18,2.36192881 18,2.5 L18,2.5 L18,7.5 C18,7.77614237 17.7761424,8 17.5,8 C17.2238576,8 17,7.77614237 17,7.5 L17,3.66553402 L10.1960487,10.4694853 L10.1960487,10.4694853 C10.0007866,10.6647474 9.68420409,10.6647474 9.48894195,10.4694853 L9.48894195,10.4694853 C9.2936798,10.2742231 9.2936798,9.95764066 9.48894195,9.76237851 L16.2513205,3 Z M3,6 L3,17 L15,17 C15,12.8507616 15,10.6840949 15,10.5 C15,10.2238576 15.2238576,10 15.5,10 C15.8333333,10.1492384 16,10.3159051 16,10.5 L16,17.5 C16,17.7761424 15.7761424,18 15.5,18 L2.5,18 C2.22385763,18 2,17.7761424 2,17.5 L2,5.5 C2,5.22385763 2.22385763,5 2.5,5 L8.5,5 C8.77614237,5 9,5.22385763 9,5.5 C9,5.77614237 8.77614237,6 8.5,6 L3,6 Z" })));
};
export default NewTab;
